import React from 'react';
import logo from '../../shared/assets/images/logoHeader.svg';
import S from './Header.module.scss';
import {useScrollToSection} from "../../shared/hook/useScrollToSection";
import {useDisclosure} from "@mantine/hooks";
import {ModalWindow} from "../modal";
import vk from "../../shared/assets/images/vk2.png";
import rutube from '../../shared/assets/images/rutube.png';

interface HeaderMobileProps {
  onClose: () => void;
}

export const HeaderMobile: React.FC<HeaderMobileProps> = ({ onClose }) => {
  const scrollToSection = useScrollToSection();
  const [openedModal, {open: openModal, close: closeModal}] = useDisclosure(false);

  return (
    <div className={S.headerMobile}>
      <div className={S.headerMobile_title}>
        <button className={S.closeButton} onClick={onClose} aria-label="Закрыть">
          ✕
        </button>
        <div className={S.headerMobile_logo} onClick={() => scrollToSection('announcements')}>
          <img src={logo} alt="Logo" />
        </div>
      </div>

        <nav className={S.headerMobile_menu}>
            <div className={S.headerMobile_menuItem} onClick={() => scrollToSection('announcements')}>Мероприятия</div>
            <div className={S.headerMobile_menuItem} onClick={() => scrollToSection('about')}>О нас</div>
            <div className={S.headerMobile_menuItem} onClick={() => scrollToSection('archive')}>Архив</div>
            <div className={S.headerMobile_menuItem} onClick={() => scrollToSection('partners')}>Партнёры</div>
            <div className={S.headerMobile_menuItem} onClick={() => scrollToSection('contacts')}>Контакты</div>
        </nav>

        <div className={S.headerMobile_footer}>
            <div className={S.registrationMobile} onClick={openModal}>РЕГИСТРАЦИЯ</div>
            <a href="tel:+79220197166" className={S.headerMobile_phone}>+7 (922) 019-71-66</a>
            <div className={S.headerMobile_footerText}>
                <div>info@evoforum.ru</div>
            </div>
            <div className={S.headerMobile_footerDiv}>
                <img src={vk} alt="vk"/>
                <a href="https://vk.ru/club241247865" target="_blank" rel="noreferrer" className={S.headerMobile_link}>
                    vk.ru/evoforum
                </a>
            </div>
            <div className={S.headerMobile_footerDiv}>
                <img src={rutube} alt="rutube"/>
                <a href="https://rutube.ru/channel/80952490" target="_blank" rel="noreferrer" className={S.headerMobile_link}>
                    rutube.ru/evoforum
                </a>
            </div>
        </div>
        <ModalWindow
            opened={openedModal}
            close={closeModal}
        />
    </div>
  );
};